import type { Locale } from '@ecomm/utils'

/**
 * Return `true` if the site locale is en-US
 */
export const isSiteUS = (locale: Locale): boolean => locale === 'en-US'
